import { PropTypes } from 'prop-types';
import React from 'react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { BREAKPOINTS } from '../../../constants/breakpoints';
import { COLORS } from '../../../constants/colors';
import { toCamelCase } from '../../../utils';
import { setSlides } from './CarouselEffects';
import { cardOptionsMap, cardsMap } from './CarouselMappings';

SwiperCore.use([Pagination, Navigation]);

const Carousel = (props) => {
  const { data, type = 'standard' } = props;
  const { background } = data;
  const getColor = COLORS[toCamelCase(background)];
  const long = type === 'long';
  const { bodyCards, endCard, titleCard } = data;
  const cardData = [titleCard, ...bodyCards, endCard]
    .filter((card) => card)
    .map((card) => {
      const {
        id: cardId,
        internal: { type: internalType },
      } = card;
      return React.createElement(cardsMap[internalType], {
        data: card,
        key: cardId,
        long,
        options: cardOptionsMap[internalType],
      });
    });

  return (
    <div className={`carousel-wrapper ${toCamelCase(background)}`}>
      <Swiper
        allowTouchMove
        breakpoints={{
          [BREAKPOINTS.tabletMD]: {
            allowTouchMove: false,
            effect: 'slide',
            threshold: 200,
            virtualTranslate: false,
          },
        }}
        effect="stack"
        navigation
        onBreakpoint={(swiper, params) => {
          swiper.el.children[3].removeAttribute('style');
          if (params.effect !== 'stack') {
            const slides = Object.values(swiper.slides);
            slides.forEach((slide) => {
              const getSlide = slide;
              getSlide.removeAttribute('style');
            });
          }
        }}
        onProgress={(swiper, progress) => {
          if (swiper.params.effect !== 'stack') {
            return;
          }
          const slides = Object.values(swiper.slides);

          const alpha = progress * (slides.length - 1) - swiper.activeIndex;

          setSlides(swiper, slides, alpha, getColor);
        }}
        onSetTransition={(swiper) => {
          if (swiper.params.effect !== 'stack') return;
          const slides = Object.values(swiper.slides);
          slides.forEach((slide, index) => {
            const getSlide = slide;
            getSlide.removeAttribute('style');
            getSlide.style.zIndex = slides.length - index;
            getSlide.style.background = getColor;
            getSlide.style.transition = 'all 0.333s ease-in-out';
          });
        }}
        onTransitionStart={(swiper) => {
          // Pagination
          // Add active class to trailing bullets in pagination for staggered progress effect
          const bullets = swiper.pagination.$el[0].children;
          for (let i = 0; i < bullets.length; i += 1) {
            if (i <= swiper.activeIndex) {
              bullets[i].className =
                'swiper-pagination-bullet swiper-pagination-bullet-viewed';
            }
          }
        }}
        pagination={{
          bulletActiveClass: 'swiper-pagination-bullet-viewed',
          clickable: true,
          type: 'bullets',
        }}
        // plugins
        speed={333}
        threshold={0}
        virtualTranslate
      >
        {cardData.map((slideItem) =>
          React.createElement(SwiperSlide, { key: slideItem.key }, slideItem),
        )}
      </Swiper>
    </div>
  );
};

Carousel.propTypes = {
  data: PropTypes.object,
  type: PropTypes.oneOf(['standard', 'long']),
};

export default Carousel;
